/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

/**
 * CompleteyourBedPillow Input Action
 */
export class CompleteYourBedPillowInput implements Msdyn365.IActionInput {
    public pillow: SimpleProduct | undefined | null;
    // Construct the input needed to run the action
    constructor(pillow: SimpleProduct | undefined | null) {
        this.pillow = pillow;
    }

    // Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CompleteyourBedPillow`;
    public getCacheObjectType = () => 'CompleteyourBedPillow';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// Create a data model here or import one to capture the response of the action
export interface ICompleteYourBedPillowData {
    pillow: SimpleProduct | undefined | null;
}

/**
 * Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext<ICompleteYourBedPillowData>): Msdyn365.IActionInput => {
    return new CompleteYourBedPillowInput(args?.config?.pillow);
};

/**
 * Use this function to call your action and process the results as needed
 */
async function action(input: CompleteYourBedPillowInput, ctx: Msdyn365.IActionContext): Promise<ICompleteYourBedPillowData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<ISelectYourFoundationData[]>('/get/example/id/1', 'get');
    return { pillow: input.pillow };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICompleteYourBedPillowData>>action,
    // Give your data action a unique id
    id: 'CompleteyourBedPillow',
    input: createInput
    // Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
